import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { StorageService } from "./storage.service";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class SessionService {
  constructor(private indexedDB: StorageService, private http: HttpClient) {}

  logout() {
    let token = sessionStorage.getItem("token");
    localStorage.clear();
    sessionStorage.clear();
    this.indexedDB.clear();
    this.authRevoke({ token: token }).subscribe((res: any) => {
      window.location.href = environment.openAM + environment.hostURL;
    });
  }

  redirectToLogin(currentURL: string) {
    this.storeCurrentLocation(currentURL);
    sessionStorage.removeItem("inactiveSession");
     window.location.href = environment.openAmRedirect +
      environment.hostURL +
      "#login";
  }

  authRevoke(payload: any) {
    const url =
      environment.onDemand.baseUrl +
      environment.onDemand.apiAuth.split("?")[0].replace(/token$/, "revoke");

    const body = new URLSearchParams();
    body.set("token", payload.token);
    body.set("client_id", "sso-client");
    body.set("client_secret", "secret");

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return this.http.post(url, body.toString(), { headers });
  }

  storeCurrentLocation(currentURL: string) {
   // debugger;
    sessionStorage.setItem("redirectURL", currentURL);
  }
}
